import { useEffect, useState } from 'react'

const SCENE_DURATION_MS = 5500

/** Rotates a scene index 0..count-1 on a 5.5s interval.
 *  Honors `prefers-reduced-motion: reduce` by locking at 0. */
export function useHeroScene(count: number) {
  const [scene, setScene] = useState(0)
  const [isReducedMotion, setIsReducedMotion] = useState(
    typeof window !== 'undefined' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)')
    const onChange = (e: MediaQueryListEvent) => setIsReducedMotion(e.matches)
    mql.addEventListener('change', onChange)
    return () => mql.removeEventListener('change', onChange)
  }, [])

  useEffect(() => {
    if (isReducedMotion || count < 2) return
    const id = window.setInterval(() => {
      setScene((s) => (s + 1) % count)
    }, SCENE_DURATION_MS)
    return () => window.clearInterval(id)
  }, [count, isReducedMotion])

  return { scene, isReducedMotion }
}
